// extracted by mini-css-extract-plugin
module.exports = {"list":"Step2--list--3eZrD","spinner":"Step2--spinner--UAUN5"};